/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../../generated/graphqlTypes";

import { gql } from "@apollo/client";
import { TableListFragmentDoc } from "./DataBrowserTableList.generated";
import {
  CategoryFragmentDoc,
  StatusFragmentDoc,
} from "../../app/ProjectLabels.generated";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type PinnedTablesQueryVariables = Types.Exact<{
  hexId: Types.InputMaybe<Types.Scalars["HexId"]["input"]>;
}>;

export type PinnedTablesQuery = {
  readonly __typename: "Query";
  readonly me: {
    readonly __typename: "User";
    readonly id: c.UserId;
    readonly pinnedTables: ReadonlyArray<{
      readonly __typename: "DataSourceTable";
      readonly id: c.DataSourceTableId;
      readonly name: string;
      readonly comment: string | null;
      readonly columnCount: number;
      readonly dataConnectionId: c.DataConnectionId;
      readonly tableType: Types.TableType | null;
      readonly dbtDescriptionMdStripped: string | null;
      readonly pinned: boolean;
      readonly pinnedAt: c.DateTimeString | null;
      readonly metadata: {
        readonly __typename: "DataSourceTableMetadata";
        readonly id: c.DataSourceTableMetadataId;
        readonly magicDescription: string | null;
        readonly status: {
          readonly __typename: "Status";
          readonly id: c.StatusId;
          readonly name: string;
          readonly color: Types.HexColor;
          readonly description: string | null;
          readonly inLibrary: boolean;
          readonly endorsed: boolean;
          readonly icon: Types.IconType | null;
        } | null;
        readonly categories: ReadonlyArray<{
          readonly __typename: "Category";
          readonly id: c.CategoryId;
          readonly name: string;
          readonly color: Types.HexColor;
          readonly description: string | null;
        }>;
      } | null;
      readonly dataSourceSchema: {
        readonly __typename: "DataSourceSchema";
        readonly id: c.DataSourceSchemaId;
        readonly name: string;
        readonly dataSourceDatabase: {
          readonly __typename: "DataSourceDatabase";
          readonly id: c.DataSourceDatabaseId;
          readonly name: string | null;
        };
      };
    }>;
  } | null;
};

export type PinnedSchemaFragment = {
  readonly __typename: "DataSourceSchema";
  readonly id: c.DataSourceSchemaId;
  readonly pinned: boolean;
  readonly pinnedAt: c.DateTimeString | null;
  readonly name: string;
  readonly dataConnectionId: c.DataConnectionId;
  readonly tableCount: number;
  readonly metadata: {
    readonly __typename: "DataSourceSchemaMetadata";
    readonly id: c.DataSourceSchemaMetadataId;
    readonly magicDescription: string | null;
    readonly status: {
      readonly __typename: "Status";
      readonly id: c.StatusId;
      readonly name: string;
      readonly color: Types.HexColor;
      readonly description: string | null;
      readonly inLibrary: boolean;
      readonly endorsed: boolean;
      readonly icon: Types.IconType | null;
    } | null;
    readonly categories: ReadonlyArray<{
      readonly __typename: "Category";
      readonly id: c.CategoryId;
      readonly name: string;
      readonly color: Types.HexColor;
      readonly description: string | null;
    }>;
  } | null;
  readonly dataSourceDatabase: {
    readonly __typename: "DataSourceDatabase";
    readonly id: c.DataSourceDatabaseId;
    readonly name: string | null;
  };
};

export type PinnedSchemasQueryVariables = Types.Exact<{
  hexId: Types.InputMaybe<Types.Scalars["HexId"]["input"]>;
}>;

export type PinnedSchemasQuery = {
  readonly __typename: "Query";
  readonly me: {
    readonly __typename: "User";
    readonly id: c.UserId;
    readonly pinnedSchemas: ReadonlyArray<{
      readonly __typename: "DataSourceSchema";
      readonly id: c.DataSourceSchemaId;
      readonly pinned: boolean;
      readonly pinnedAt: c.DateTimeString | null;
      readonly name: string;
      readonly dataConnectionId: c.DataConnectionId;
      readonly tableCount: number;
      readonly metadata: {
        readonly __typename: "DataSourceSchemaMetadata";
        readonly id: c.DataSourceSchemaMetadataId;
        readonly magicDescription: string | null;
        readonly status: {
          readonly __typename: "Status";
          readonly id: c.StatusId;
          readonly name: string;
          readonly color: Types.HexColor;
          readonly description: string | null;
          readonly inLibrary: boolean;
          readonly endorsed: boolean;
          readonly icon: Types.IconType | null;
        } | null;
        readonly categories: ReadonlyArray<{
          readonly __typename: "Category";
          readonly id: c.CategoryId;
          readonly name: string;
          readonly color: Types.HexColor;
          readonly description: string | null;
        }>;
      } | null;
      readonly dataSourceDatabase: {
        readonly __typename: "DataSourceDatabase";
        readonly id: c.DataSourceDatabaseId;
        readonly name: string | null;
      };
    }>;
  } | null;
};

export type PinnedSemanticDatasetFragment = {
  readonly __typename: "SemanticDataset";
  readonly id: c.SemanticDatasetId;
  readonly pinned: boolean;
  readonly pinnedAt: c.DateTimeString | null;
  readonly name: c.SemanticDatasetName;
  readonly title: string | null;
  readonly description: string | null;
  readonly status: {
    readonly __typename: "Status";
    readonly id: c.StatusId;
  } | null;
  readonly categories: ReadonlyArray<{
    readonly __typename: "Category";
    readonly id: c.CategoryId;
  }>;
  readonly semanticProject: {
    readonly __typename: "SemanticProject";
    readonly id: c.SemanticProjectId;
    readonly name: string;
    readonly dataConnection: {
      readonly __typename: "DataConnection";
      readonly id: c.DataConnectionId;
    } | null;
  };
};

export type PinnedSemanticDatasetsQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type PinnedSemanticDatasetsQuery = {
  readonly __typename: "Query";
  readonly me: {
    readonly __typename: "User";
    readonly id: c.UserId;
    readonly pinnedSemanticDatasets: ReadonlyArray<{
      readonly __typename: "SemanticDataset";
      readonly id: c.SemanticDatasetId;
      readonly pinned: boolean;
      readonly pinnedAt: c.DateTimeString | null;
      readonly name: c.SemanticDatasetName;
      readonly title: string | null;
      readonly description: string | null;
      readonly status: {
        readonly __typename: "Status";
        readonly id: c.StatusId;
      } | null;
      readonly categories: ReadonlyArray<{
        readonly __typename: "Category";
        readonly id: c.CategoryId;
      }>;
      readonly semanticProject: {
        readonly __typename: "SemanticProject";
        readonly id: c.SemanticProjectId;
        readonly name: string;
        readonly dataConnection: {
          readonly __typename: "DataConnection";
          readonly id: c.DataConnectionId;
        } | null;
      };
    }>;
  } | null;
};

export type PinnedSemanticViewFragment = {
  readonly __typename: "SemanticView";
  readonly id: c.SemanticViewId;
  readonly pinned: boolean;
  readonly pinnedAt: c.DateTimeString | null;
  readonly name: c.SemanticViewName;
  readonly title: string | null;
  readonly description: string | null;
  readonly status: {
    readonly __typename: "Status";
    readonly id: c.StatusId;
  } | null;
  readonly categories: ReadonlyArray<{
    readonly __typename: "Category";
    readonly id: c.CategoryId;
  }>;
  readonly semanticProject: {
    readonly __typename: "SemanticProject";
    readonly id: c.SemanticProjectId;
    readonly name: string;
    readonly dataConnection: {
      readonly __typename: "DataConnection";
      readonly id: c.DataConnectionId;
    } | null;
  };
};

export type PinnedSemanticViewsQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type PinnedSemanticViewsQuery = {
  readonly __typename: "Query";
  readonly me: {
    readonly __typename: "User";
    readonly id: c.UserId;
    readonly pinnedSemanticViews: ReadonlyArray<{
      readonly __typename: "SemanticView";
      readonly id: c.SemanticViewId;
      readonly pinned: boolean;
      readonly pinnedAt: c.DateTimeString | null;
      readonly name: c.SemanticViewName;
      readonly title: string | null;
      readonly description: string | null;
      readonly status: {
        readonly __typename: "Status";
        readonly id: c.StatusId;
      } | null;
      readonly categories: ReadonlyArray<{
        readonly __typename: "Category";
        readonly id: c.CategoryId;
      }>;
      readonly semanticProject: {
        readonly __typename: "SemanticProject";
        readonly id: c.SemanticProjectId;
        readonly name: string;
        readonly dataConnection: {
          readonly __typename: "DataConnection";
          readonly id: c.DataConnectionId;
        } | null;
      };
    }>;
  } | null;
};

export const PinnedSchemaFragmentDoc = /*#__PURE__*/ gql`
  fragment PinnedSchemaFragment on DataSourceSchema {
    id
    pinned
    pinnedAt
    name
    dataConnectionId
    metadata {
      id
      magicDescription
      status {
        ...StatusFragment
      }
      categories {
        ...CategoryFragment
      }
    }
    dataSourceDatabase {
      id
      name
    }
    tableCount
  }
  ${StatusFragmentDoc}
  ${CategoryFragmentDoc}
`;
export const PinnedSemanticDatasetFragmentDoc = /*#__PURE__*/ gql`
  fragment PinnedSemanticDatasetFragment on SemanticDataset {
    id
    pinned
    pinnedAt
    name
    title
    status {
      id
    }
    description
    categories {
      id
    }
    semanticProject {
      id
      name
      dataConnection {
        id
      }
    }
  }
`;
export const PinnedSemanticViewFragmentDoc = /*#__PURE__*/ gql`
  fragment PinnedSemanticViewFragment on SemanticView {
    id
    pinned
    pinnedAt
    name
    title
    description
    status {
      id
    }
    categories {
      id
    }
    semanticProject {
      id
      name
      dataConnection {
        id
      }
    }
  }
`;
export const PinnedTablesDocument = /*#__PURE__*/ gql`
  query PinnedTables($hexId: HexId) {
    me {
      id
      pinnedTables(hexId: $hexId) {
        id
        ...TableListFragment
      }
    }
  }
  ${TableListFragmentDoc}
`;

/**
 * __usePinnedTablesQuery__
 *
 * To run a query within a React component, call `usePinnedTablesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePinnedTablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePinnedTablesQuery({
 *   variables: {
 *      hexId: // value for 'hexId'
 *   },
 * });
 */
export function usePinnedTablesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PinnedTablesQuery,
    PinnedTablesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PinnedTablesQuery, PinnedTablesQueryVariables>(
    PinnedTablesDocument,
    options,
  );
}
export function usePinnedTablesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PinnedTablesQuery,
    PinnedTablesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PinnedTablesQuery, PinnedTablesQueryVariables>(
    PinnedTablesDocument,
    options,
  );
}
// @ts-ignore
export function usePinnedTablesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    PinnedTablesQuery,
    PinnedTablesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<PinnedTablesQuery, PinnedTablesQueryVariables>;
export function usePinnedTablesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PinnedTablesQuery,
        PinnedTablesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  PinnedTablesQuery | undefined,
  PinnedTablesQueryVariables
>;
export function usePinnedTablesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PinnedTablesQuery,
        PinnedTablesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<PinnedTablesQuery, PinnedTablesQueryVariables>(
    PinnedTablesDocument,
    options,
  );
}
export type PinnedTablesQueryHookResult = ReturnType<
  typeof usePinnedTablesQuery
>;
export type PinnedTablesLazyQueryHookResult = ReturnType<
  typeof usePinnedTablesLazyQuery
>;
export type PinnedTablesSuspenseQueryHookResult = ReturnType<
  typeof usePinnedTablesSuspenseQuery
>;
export type PinnedTablesQueryResult = Apollo.QueryResult<
  PinnedTablesQuery,
  PinnedTablesQueryVariables
>;
export const PinnedSchemasDocument = /*#__PURE__*/ gql`
  query PinnedSchemas($hexId: HexId) {
    me {
      id
      pinnedSchemas(hexId: $hexId) {
        id
        ...PinnedSchemaFragment
      }
    }
  }
  ${PinnedSchemaFragmentDoc}
`;

/**
 * __usePinnedSchemasQuery__
 *
 * To run a query within a React component, call `usePinnedSchemasQuery` and pass it any options that fit your needs.
 * When your component renders, `usePinnedSchemasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePinnedSchemasQuery({
 *   variables: {
 *      hexId: // value for 'hexId'
 *   },
 * });
 */
export function usePinnedSchemasQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PinnedSchemasQuery,
    PinnedSchemasQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PinnedSchemasQuery, PinnedSchemasQueryVariables>(
    PinnedSchemasDocument,
    options,
  );
}
export function usePinnedSchemasLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PinnedSchemasQuery,
    PinnedSchemasQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PinnedSchemasQuery, PinnedSchemasQueryVariables>(
    PinnedSchemasDocument,
    options,
  );
}
// @ts-ignore
export function usePinnedSchemasSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    PinnedSchemasQuery,
    PinnedSchemasQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  PinnedSchemasQuery,
  PinnedSchemasQueryVariables
>;
export function usePinnedSchemasSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PinnedSchemasQuery,
        PinnedSchemasQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  PinnedSchemasQuery | undefined,
  PinnedSchemasQueryVariables
>;
export function usePinnedSchemasSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PinnedSchemasQuery,
        PinnedSchemasQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PinnedSchemasQuery,
    PinnedSchemasQueryVariables
  >(PinnedSchemasDocument, options);
}
export type PinnedSchemasQueryHookResult = ReturnType<
  typeof usePinnedSchemasQuery
>;
export type PinnedSchemasLazyQueryHookResult = ReturnType<
  typeof usePinnedSchemasLazyQuery
>;
export type PinnedSchemasSuspenseQueryHookResult = ReturnType<
  typeof usePinnedSchemasSuspenseQuery
>;
export type PinnedSchemasQueryResult = Apollo.QueryResult<
  PinnedSchemasQuery,
  PinnedSchemasQueryVariables
>;
export const PinnedSemanticDatasetsDocument = /*#__PURE__*/ gql`
  query PinnedSemanticDatasets {
    me {
      id
      pinnedSemanticDatasets {
        id
        ...PinnedSemanticDatasetFragment
      }
    }
  }
  ${PinnedSemanticDatasetFragmentDoc}
`;

/**
 * __usePinnedSemanticDatasetsQuery__
 *
 * To run a query within a React component, call `usePinnedSemanticDatasetsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePinnedSemanticDatasetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePinnedSemanticDatasetsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePinnedSemanticDatasetsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PinnedSemanticDatasetsQuery,
    PinnedSemanticDatasetsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PinnedSemanticDatasetsQuery,
    PinnedSemanticDatasetsQueryVariables
  >(PinnedSemanticDatasetsDocument, options);
}
export function usePinnedSemanticDatasetsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PinnedSemanticDatasetsQuery,
    PinnedSemanticDatasetsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PinnedSemanticDatasetsQuery,
    PinnedSemanticDatasetsQueryVariables
  >(PinnedSemanticDatasetsDocument, options);
}
// @ts-ignore
export function usePinnedSemanticDatasetsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    PinnedSemanticDatasetsQuery,
    PinnedSemanticDatasetsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  PinnedSemanticDatasetsQuery,
  PinnedSemanticDatasetsQueryVariables
>;
export function usePinnedSemanticDatasetsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PinnedSemanticDatasetsQuery,
        PinnedSemanticDatasetsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  PinnedSemanticDatasetsQuery | undefined,
  PinnedSemanticDatasetsQueryVariables
>;
export function usePinnedSemanticDatasetsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PinnedSemanticDatasetsQuery,
        PinnedSemanticDatasetsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PinnedSemanticDatasetsQuery,
    PinnedSemanticDatasetsQueryVariables
  >(PinnedSemanticDatasetsDocument, options);
}
export type PinnedSemanticDatasetsQueryHookResult = ReturnType<
  typeof usePinnedSemanticDatasetsQuery
>;
export type PinnedSemanticDatasetsLazyQueryHookResult = ReturnType<
  typeof usePinnedSemanticDatasetsLazyQuery
>;
export type PinnedSemanticDatasetsSuspenseQueryHookResult = ReturnType<
  typeof usePinnedSemanticDatasetsSuspenseQuery
>;
export type PinnedSemanticDatasetsQueryResult = Apollo.QueryResult<
  PinnedSemanticDatasetsQuery,
  PinnedSemanticDatasetsQueryVariables
>;
export const PinnedSemanticViewsDocument = /*#__PURE__*/ gql`
  query PinnedSemanticViews {
    me {
      id
      pinnedSemanticViews {
        id
        ...PinnedSemanticViewFragment
      }
    }
  }
  ${PinnedSemanticViewFragmentDoc}
`;

/**
 * __usePinnedSemanticViewsQuery__
 *
 * To run a query within a React component, call `usePinnedSemanticViewsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePinnedSemanticViewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePinnedSemanticViewsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePinnedSemanticViewsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PinnedSemanticViewsQuery,
    PinnedSemanticViewsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PinnedSemanticViewsQuery,
    PinnedSemanticViewsQueryVariables
  >(PinnedSemanticViewsDocument, options);
}
export function usePinnedSemanticViewsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PinnedSemanticViewsQuery,
    PinnedSemanticViewsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PinnedSemanticViewsQuery,
    PinnedSemanticViewsQueryVariables
  >(PinnedSemanticViewsDocument, options);
}
// @ts-ignore
export function usePinnedSemanticViewsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    PinnedSemanticViewsQuery,
    PinnedSemanticViewsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  PinnedSemanticViewsQuery,
  PinnedSemanticViewsQueryVariables
>;
export function usePinnedSemanticViewsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PinnedSemanticViewsQuery,
        PinnedSemanticViewsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  PinnedSemanticViewsQuery | undefined,
  PinnedSemanticViewsQueryVariables
>;
export function usePinnedSemanticViewsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PinnedSemanticViewsQuery,
        PinnedSemanticViewsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PinnedSemanticViewsQuery,
    PinnedSemanticViewsQueryVariables
  >(PinnedSemanticViewsDocument, options);
}
export type PinnedSemanticViewsQueryHookResult = ReturnType<
  typeof usePinnedSemanticViewsQuery
>;
export type PinnedSemanticViewsLazyQueryHookResult = ReturnType<
  typeof usePinnedSemanticViewsLazyQuery
>;
export type PinnedSemanticViewsSuspenseQueryHookResult = ReturnType<
  typeof usePinnedSemanticViewsSuspenseQuery
>;
export type PinnedSemanticViewsQueryResult = Apollo.QueryResult<
  PinnedSemanticViewsQuery,
  PinnedSemanticViewsQueryVariables
>;
